import React from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledH2, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";
import { uuid } from "uuidv4";

import { store } from "@components/VerticalLayout/store";
import {
    store as languageStore,
    setNumberActive,
    setNumberArchived,
    setGlobalDataIsUpdated,
    setKey,
    setIsLoading,
} from "../store";
import { generalConfigStore, setItemsDisable } from "@store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import ErrorToast from "@components/Common/ErrorTost";
import { ShowSuccessToast } from "../ShowSuccessToast";
import {
    apiRequest,
    ArchivedLanguagesShop,
    createLanguageItem,
} from "../hooks";
import { useFetchGlobal } from "../../../../api/hooks";

type ConfirmationDeleteMessageType = {
    setModalState: Function;
    modalState: any;
    isOneShop: boolean;
    setTableState: any;
    tableState: any;
};

export function ConfirmationActiveLanguage({
    setModalState,
    modalState,
    tableState,
    setTableState,
}: ConfirmationDeleteMessageType) {
    const { fetchGlobal } = useFetchGlobal();
    const { t } = useTranslation();
    const { userID, franchiseID, operatorID } = useSnapshot(store);
    const { numberActive, numberArchived, shopsLanguagesData } = useSnapshot(
        languageStore
    );
    const { itemsDisable } = useSnapshot(generalConfigStore);

    const uuidUser = localStorage.getItem("uuidUser");

    async function activeLanguage(isValidation: boolean) {
        setIsLoading(true);
        toast.dismiss();
        let item: any = [];
        let languageData: any = {};
        let shopIds: any = [];
        tableState.selectedRows.forEach((element: any) => {
            const id = element.Id;
            let shopsArchived = isValidation
                ? ArchivedLanguagesShop(element, shopsLanguagesData)
                : [element.shopId];
            shopsArchived.forEach((el: any) => {
                if (!shopIds.includes(el.toString())) {
                    shopIds.push(el.toString());
                    languageData[el.toString()] = {};
                }
                if (
                    el !== "0" &&
                    itemsDisable.find(
                        (elem: any) => elem.shopId === el && elem.id === id
                    ) === undefined &&
                    el.isActive === false
                ) {
                    item.push({
                        id: id,
                        state: false,
                        shopId: el,
                    });
                }
                Object.assign(languageData[el.toString()], {
                    ...createLanguageItem(
                        element,
                        id,
                        el.toString() === "0" ? true : false,
                        false,
                        false,
                        el.toString()
                    ),
                });
            });
        });
        let dataLanguage = {
            userId: userID,
            shopId: shopIds,
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            isShop: false,
            data: languageData,
            isMultiShop: true,
        };
        try {
            const result: any = await apiRequest(dataLanguage, fetchGlobal);
            if (result.error) {
                throw new Error("error");
            }
            setItemsDisable(item);
            localStorage.setItem("itemsDisable", JSON.stringify(item));
            ShowSuccessToast(
                `${t("The language was successfully unarchived")}`
            );
            setTableState({
                ...tableState,
                dataIsUpdated: !tableState.dataIsUpdated,
            });
            setGlobalDataIsUpdated(true);
            setKey(uuid());
            setIsLoading(false);
        } catch (e) {
            ErrorToast(`${t("There's an error")}`);
            setIsLoading(false);
        }
    }

    return (
        <StyledModal toggle={true} isOpen={modalState.isModalOpened!} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setModalState({
                        ...modalState,
                        isModalOpened: false,
                    });
                    setTableState({
                        ...tableState,
                        dataIsUpdated: !tableState.dataIsUpdated,
                    });
                }}
            >
                <StyledH2 className="text-uppercase">{t("Alert")}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel className="pl-3 m-0">
                    {t(
                        "Attention! the language is archived at store level. Do you want to activate it in shops too?"
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={async () => {
                        await activeLanguage(false);
                        setModalState({
                            ...modalState,
                            isModalOpened: false,
                        });
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={async () => {
                        await activeLanguage(true);
                        setModalState({
                            ...modalState,
                            isModalOpened: false,
                        });
                        setNumberActive(
                            tableState.selectedRows.length !== 0
                                ? numberActive + tableState.selectedRows.length
                                : numberActive + 1
                        );
                        setNumberArchived(
                            tableState.selectedRows.length !== 0
                                ? numberArchived -
                                      tableState.selectedRows.length
                                : numberArchived - 1
                        );
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
